<template>
  <div v-if="show">
    <div @click="closeCurtain()" id="dark-backdrop" class="dark-backdrop"></div>

    <!-- <span style="cursor: pointer" @click="openCurtain()">open</span> -->

    <div id="CurtainMenu" class="overlay">
      <div class="curtain-header">
        <b-icon
          @click="closeCurtain()"
          class="close-icon"
          icon="x"
          scale="2"
        ></b-icon>
        <h1 class="curtain-header-text">{{ user.name }}</h1>
      </div>
      <div class="curtain-body">
        <div class="section">
          <div class="section-header">
            کاربر سطح {{ toPersianNum(user.level) }}
          </div>
          <a href="#" class="section-link">
            افزایش سطح کاربری
            <b-icon
              style="padding-top: 7px"
              icon="chevron-left"
              scale="2"
            ></b-icon>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "curtain-menu",
  props: {
    show: {
      type: Boolean,
      default: false,
      description:
        "Whether curtain menu is shown (valid for viewports < specified by `expand` prop)",
    },
    user: {
      type: Object,
      description:
        "Whether navbar menu is shown (valid for viewports < specified by `expand` prop)",
    },
  },
  model: {
    prop: "show",
    event: "change",
  },
  computed: {},
  methods: {
    openCurtain() {
      document.getElementById("CurtainMenu").style.height = "75%";
      document.getElementById("dark-backdrop").style.display = "block";
      document.getElementById("dark-backdrop").style.height = "100%";
    },
    closeCurtain() {
      document.getElementById("CurtainMenu").style.height = "0%";
      document.getElementById("dark-backdrop").style.height = "0%";
      document.getElementById("dark-backdrop").style.display = "none";
    },
    toggleMenu() {
      this.$emit("change", !this.show);
    },
    closeMenu() {
      this.$emit("change", false);
    },
  },
};
</script>

<style>
.dark-backdrop {
  display: none;
  height: 0%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  height: 100%;
  width: 100%;
  z-index: 1030;
}

.overlay {
  direction: rtl;
  text-align: right;
  height: 0%;
  width: 100%;
  position: fixed;
  z-index: 3000;
  bottom: 0;
  /* left: 0; */
  background-color: #fff;
  overflow-y: hidden;
  transition: 0.5s;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
}

.overlay .curtain-header {
  padding: 24px 16px 24px 16px;
}

.overlay .close-icon {
  width: 14px;
  height: 14px;
  margin-left: 21px;
}

.overlay .curtain-header .curtain-header-text {
  font-size: 18px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: right;
  color: #212121;
  margin-bottom: 0;
  display: inline;
}

.overlay .curtain-body .section {
  padding: 16px;
  border-top: 1px solid #d8d8d8;
}

.overlay .curtain-body .section .section-header {
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: right;
  color: #212121;
  margin-bottom: 20px;
}

.overlay .curtain-body .section .section-link {
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: right;
  color: #2a6ae3;
}

.overlay .curtain-body .section .section-price {
  font-size: 16px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: right;
  color: #424242;
  margin-bottom: 0px;
}

.overlay .curtain-body .section .section-price-range {
  font-size: 14px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: right;
  color: #424242;
  margin-bottom: 10px;
}

.overlay .curtain-body .section .section-sub-text {
  font-size: 14px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.57;
  letter-spacing: normal;
  text-align: right;
  color: #757575;
  margin-top: 8px;
}

@media screen and (max-height: 450px) {
  .overlay {
    overflow-y: auto;
  }
}
</style>
